import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Fine } from '../../../../../../core/models/fine/fine.model';
import { ApiFineService } from '../../../../../../core/services/api/fine/api-fine.service';
import { ApiTableService } from '../../../../../../core/services/api-table.service';
import { ToastService } from 'angular-toastify';
import { optionResponse, dataDto } from '../../../../../../core/models/form.model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-modal-fine',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-fine.component.html',
  styleUrl: './modal-fine.component.css'
})
export class ModalFineComponent implements OnInit {
  @Input() fineData: Fine | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  public form: Fine = this.getInitialForm();
  public isLoading: boolean = false;
  public openDropdown: string | null = null;

  // Dropdowns
  public siteList: optionResponse | null = null;
  public revenueOptions = ['ค่าปรับบัตรจอดรถหาย', 'ค่าปรับผิดระเบียบ', 'ค่าปรับรายชั่วโมงเกินกำหนด', 'ค่าปรับอื่นๆ'];

  constructor(
    private apiFineService: ApiFineService,
    private apiTableService: ApiTableService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    if (this.fineData) {
      this.form = { ...this.fineData };
    }
    this.fetchSites();
  }

  private getInitialForm(): Fine {
    return {
      id: 0,
      name: '',
      amount: 0,
      isVatIncluded: true,
      revenueName: '',
      site: ''
    };
  }

  private fetchSites(): void {
    this.apiTableService.getParkingSiteList().subscribe({
      next: (res) => this.siteList = res,
      error: (err) => console.error('Fetch sites error:', err)
    });
  }

  public toggleDropdown(id: string, event: Event): void {
    event.stopPropagation();
    this.openDropdown = this.openDropdown === id ? null : id;
  }

  public selectOption(field: keyof Fine, value: any): void {
    (this.form as any)[field] = value;
    this.openDropdown = null;
  }

  public onSave(): void {
    if (!this.form.name || !this.form.site) {
      this.toast.error('กรุณากรอกชื่อค่าปรับและโครงการให้ครบถ้วน');
      return;
    }

    this.isLoading = true;
    this.apiFineService.createFine(this.form)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.toast.success('บันทึกข้อมูลค่าปรับสำเร็จ');
          this.saveSuccess.emit();
          this.close.emit();
        },
        error: (err) => {
          console.error('Save error:', err);
          this.toast.error('ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
        }
      });
  }

  public onCancel(): void {
    this.close.emit();
  }
}
